import { forumUrl } from './forumMappers';

// User content is narrower than editorial reports: no embeds, styles or media
// players. Backend already sanitizes; this is an independent rendering boundary.
const allowed = new Set('p br hr strong b em i u s del blockquote h2 h3 h4 h5 h6 ul ol li a img figure figcaption table thead tbody tfoot tr th td div span pre code sup sub'.split(' '));
const drop = new Set('script style iframe object embed form input button svg math template video audio source'.split(' '));
export function sanitizeForumHtml(value) {
  const template = document.createElement('template');
  template.innerHTML = typeof value === 'string' ? value : '';
  function clean(parent) {
    Array.from(parent.childNodes).forEach(node => {
      if (node.nodeType === 8) { node.remove(); return; }
      if (node.nodeType !== 1) return;
      const tag = node.tagName.toLowerCase();
      if (drop.has(tag)) { node.remove(); return; }
      clean(node);
      if (!allowed.has(tag)) { node.replaceWith(...Array.from(node.childNodes)); return; }
      const attrs = {};
      ['href', 'src', 'title', 'alt', 'width', 'height', 'colspan', 'rowspan'].forEach(key => { attrs[key] = node.getAttribute(key); });
      Array.from(node.attributes).forEach(attr => node.removeAttribute(attr.name));
      if (attrs.title) node.setAttribute('title', attrs.title);
      if (tag === 'a' && forumUrl(attrs.href)) {
        node.setAttribute('href', forumUrl(attrs.href)); node.setAttribute('rel', 'nofollow noopener noreferrer');
      }
      if (tag === 'img') {
        if (!forumUrl(attrs.src)) { node.remove(); return; }
        node.setAttribute('src', forumUrl(attrs.src)); node.setAttribute('alt', attrs.alt || '');
        node.setAttribute('loading', 'lazy'); node.setAttribute('decoding', 'async');
        ['width', 'height'].forEach(key => { if (/^[1-9]\d{0,4}$/.test(attrs[key]) && Number(attrs[key]) <= 16000) node.setAttribute(key, attrs[key]); });
      }
      if (tag === 'td' || tag === 'th') ['colspan', 'rowspan'].forEach(key => {
        if (/^[1-9]\d?$/.test(attrs[key])) node.setAttribute(key, attrs[key]);
      });
    });
  }
  clean(template.content);
  return template.innerHTML;
}

// Text segments are rendered with interpolation and <mark>, never v-html.
export function highlightForumText(text, query) {
  const input = String(text || '');
  const terms = [...new Set((String(query || '').match(/"([^"]+)"|(\S+)/g) || []).map(term => term.replace(/^"|"$/g, '')).filter(Boolean))].sort((a, b) => b.length - a.length);
  if (!terms.length) return [{ text: input, match: false }];
  const expression = new RegExp('(' + terms.map(term => term.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')).join('|') + ')', 'gi');
  return input.split(expression).filter(part => part !== '').map(part => ({ text: part, match: terms.some(term => term.toLocaleLowerCase() === part.toLocaleLowerCase()) }));
}
